import React from 'react';
import * as LucideIcons from 'lucide-react';

const Icon = ({ name, size = 20, color, className, ...props }) => {
    const IconComponent = LucideIcons[name];
    const FallbackIcon = LucideIcons['HelpCircle'];

    if (!IconComponent) {
        return (
            <FallbackIcon
                size={size}
                color={color}
                className={className}
                {...props}
            />
        );
    }

    return (
        <IconComponent
            size={size}
            color={color}
            className={className}
            {...props}
        />
    );
};

export default Icon;
